/**
 * Referral markup, for display only.
 *
 * shipments.referral_markup and referral_rewards are server fields. No payload
 * builder in writes/ reads them, and nothing here feeds one. The rules mirror
 * Classic's BillingTable on purpose (duplicated, not shared — see HANDOFF.md):
 * the amount is the shipment field, the rate is the first reward's
 * markup_snapshot.
 */
import i18n from "../../../i18n";

const num = (value) => {
  const parsed = parseFloat(value);
  return Number.isNaN(parsed) ? 0 : parsed;
};

export const readReferral = (data) => {
  const amount = num(data?.referral_markup);
  const rewards = Array.isArray(data?.referral_rewards)
    ? data.referral_rewards
    : [];
  const reward = rewards[0] ?? null;
  const snapshot = num(reward?.markup_snapshot);
  const rate =
    snapshot > 0
      ? reward?.referral?.markup_type === "$"
        ? i18n.t("admin:invoice.referral.flat", { amount: snapshot.toFixed(2) })
        : `${snapshot}%`
      : null;
  // The reward can differ from the shipment's markup by carrier (e.g. FedEx
  // credits the referrer on a different base), so show it when it does.
  const rewardAmount = num(reward?.amount);
  const detail = [
    reward
      ? Math.abs(rewardAmount - amount) >= 0.01
        ? i18n.t("admin:invoice.referral.rewardWithAmount", {
            id: reward.id ?? "-",
            amount: rewardAmount.toFixed(2),
          })
        : i18n.t("admin:invoice.referral.reward", { id: reward.id ?? "-" })
      : i18n.t("admin:invoice.referral.noReward"),
    reward?.status,
    reward
      ? i18n.t("admin:invoice.referral.referredBy", {
          name:
            reward.referrer?.username ??
            i18n.t("admin:invoice.referral.userNumber", {
              id: reward.referrer_id ?? "-",
            }),
        })
      : null,
    rewards.length > 1
      ? i18n.t("admin:invoice.referral.rewardRows", { count: rewards.length })
      : null,
  ]
    .filter(Boolean)
    .join(" · ");
  return { amount, rate, detail };
};
